import { getModules } from "../../sdk/modules/modules";
import AddRoleModal from "./AddRoleModal";
import { useQuery } from "react-query";

const AddPermissions = ({
  closeRoleModal,
  activeIndex,
  handleNextStep,
  finishText,
  loading,
  myRole,
  setMyRole,
}) => {
  const { data: allModules } = useQuery({
    queryKey: ["modules"],
    queryFn: () => getModules(),
    initialData: [],
  });

  const handleTogglePermission = (permissionId) => {
    const alreadySelected = myRole.permissions?.includes(permissionId);

    const updatedPermissions = alreadySelected
      ? myRole.permissions.filter((id) => id !== permissionId)
      : [...(myRole.permissions || []), permissionId];

    setMyRole({
      ...myRole,
      permissions: updatedPermissions,
    });
  };

  return (
    <AddRoleModal
      closeRoleModal={closeRoleModal}
      activeIndex={activeIndex}
      handleNextStep={handleNextStep}
      finishText={finishText}
      loading={loading}
    >
      <div>
        <p className="font-medium text-[15px] text-[#222222]">
          Create a new role
        </p>
        <p className="text-[#000000] font-semibold text-[20px]">
          Set Permissions
        </p>
        <p className="text-[#5C5C5C] text-[14px] font-normal">
          Set permissions for the role you have just entered to ensure precise
          access control.
        </p>
        <div className="w-full border p-[10px] border-[#A8A8A8] my-[20px] h-[350px] rounded-[5px] bg-white overflow-y-auto">
          {allModules &&
            allModules.map((module) => (
              <div>
                <p
                  key={module.id}
                  className="text-[#000000] mb-[15px] font-bold text-[16px]"
                >
                  {module?.name}
                </p>
                {module?.permissions?.map((permission) => (
                  <div
                    key={permission?.id}
                    className="flex items-center mb-[15px] pl-[20px] justify-between"
                  >
                    <p className="text-[#000000] font-normal text-[14px]">
                      {permission?.name}
                    </p>
                    <input
                      type="checkbox"
                      checked={myRole.permissions?.includes(permission.id)}
                      onChange={() => handleTogglePermission(permission.id)}
                    />
                  </div>
                ))}
              </div>
            ))}
        </div>
      </div>
    </AddRoleModal>
  );
};

export default AddPermissions;
